import { useMemo, useRef } from 'react';
import { MessageContainerKey, MessageManager, MessageOptions } from '../message';
import { convertOldToastOptions } from './converter.old';
import { ToastComponent, ToastComponentProps as ToastComponentNewProps } from './Toast';
import type { ToastComponentProps } from './Toast.old';

interface ToastShowProps extends MessageOptions<ToastComponentProps> {
  root?: HTMLElement | null;
}

export function useToast() {
  const messageManager = useRef<MessageManager<ToastComponentNewProps>>();
  const currentRoot = useRef<HTMLElement>();
  const toast = useMemo(() => {
    if (typeof window === 'undefined') {
      return { show: () => {}, destroy: () => {} };
    }
    return {
      show(props: ToastShowProps) {
        const convertedProps = convertOldToastOptions(props);
        if (props.root && props.root !== currentRoot.current) {
          currentRoot.current = props.root;
          messageManager.current = new MessageManager({
            component: ToastComponent,
            type: 'toast',
            root_container: props.root,
          });
          messageManager.current.show(convertedProps);
        } else if (props.root && props.root === currentRoot.current) {
          messageManager.current?.show(convertedProps);
        } else {
          MessageManager.getInstance('toast').show(convertedProps);
        }
      },
      destroy(id: string, key?: MessageContainerKey) {
        if (messageManager.current) {
          messageManager.current.destroy(id, key);
        } else {
          MessageManager.getInstance('toast').destroy(id, key);
        }
      },
    };
  }, []);
  return toast;
}
